import { ColumnConfigType } from 'shared/types';
import { BannerTableItemType } from 'entities/banner/types';

export const columnConfig: ColumnConfigType<BannerTableItemType>[] = [
  {
    dataFieldName: 'id',
    name: 'ID',
    width: '5%',
  },
  {
    dataFieldName: 'app_type',
    name: 'тип',
    width: '10%',
  },
  {
    dataFieldName: 'status',
    name: 'Статус',
    width: '10%',
  },
  {
    dataFieldName: 'title',
    name: 'Имя',
    width: '30%',
  },
  {
    dataFieldName: 'description',
    name: 'Описание',
    width: '40%',
  },
];
